import checkIcon from "@tabler/icons/outline/check.svg";
import chevronDownIcon from "@tabler/icons/outline/chevron-down.svg";
import React, { useEffect, useRef, useState } from "react";

import { cn } from "@/utils/cn";

import { Icon } from "../ui";

import { type MenuItem } from "./dropdown-menu-item";

interface DropdownMenuListProps {
  item: MenuItem;
  onToggle(): void;
  handleClose(): void;
}

const DropdownMenuList = (props: DropdownMenuListProps) => {
  const { handleClose, item, onToggle } = props;

  const list = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  function handleOpen() {
    setIsOpen((prevValue) => !prevValue);
    onToggle();
  }

  function handleDocumentClick(event: Event) {
    if (list.current && !list.current.contains(event.target as Node)) {
      setIsOpen(false);
      onToggle();
    }
  }

  useEffect(() => {
    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  return (
    <div ref={list}>
      <button
        type="button"
        onClick={handleOpen}
        className="flex w-full cursor-pointer items-center justify-between rounded-md px-4 py-2.5 text-sm text-gray-900 hover:bg-gray-100 focus:bg-gray-100 focus:outline-hidden dark:text-gray-100 dark:hover:bg-gray-800 dark:focus:bg-gray-800"
      >
        <span className="font-medium">{item.text}</span>

        <Icon
          src={chevronDownIcon}
          className="size-4 text-gray-900 dark:text-white"
        />
      </button>

      <ul
        className={cn({
          hidden: !isOpen,
        })}
      >
        {item.items?.map((innerItem) => (
          <li className="truncate" key={innerItem.text}>
            <button
              type="button"
              className="flex w-full cursor-pointer items-center justify-between rounded-md px-4 py-1 text-xs text-gray-700 hover:bg-gray-100 focus:bg-gray-100 focus:outline-hidden dark:text-gray-500 dark:hover:bg-gray-800 dark:focus:bg-gray-800"
              onClick={() => {
                innerItem.onSelect();
                handleClose();
              }}
            >
              <span>{innerItem.text}</span>

              {innerItem.isSelected && (
                <Icon
                  src={checkIcon}
                  className="size-3 text-gray-500 dark:text-gray-700"
                />
              )}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DropdownMenuList;
